import { render, staticRenderFns } from "./ViewTask.vue?vue&type=template&id=ca2d617a&scoped=true&"
import script from "./ViewTask.vue?vue&type=script&lang=js&"
export * from "./ViewTask.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms/theme-checkbox-radio.css?vue&type=style&index=0&id=ca2d617a&scoped=true&lang=css&"
import style1 from "@/assets/css/forms/switches.css?vue&type=style&index=1&id=ca2d617a&scoped=true&lang=css&"
import style2 from "./ViewTask.vue?vue&type=style&index=2&lang=css&"
import style3 from "@/assets/css/components/timeline/custom-timeline.css?vue&type=style&index=3&id=ca2d617a&scoped=true&lang=css&"
import style4 from "./ViewTask.vue?vue&type=style&index=4&lang=css&"
import style5 from "./ViewTask.vue?vue&type=style&index=5&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2d617a",
  null
  
)

export default component.exports